/**
 * Polyfills
 * - NodeList.forEach()
 * - Element.closest()
 */
// NodeList.forEach()
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// Element.closest()
if (!Element.prototype.matches)
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
  Element.prototype.webkitMatchesSelector;
if (!Element.prototype.closest)
  Element.prototype.closest = function (s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null);
    return null;
  };


! function () {
  var lastBtn = null
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    lastBtn = e.target.closest('button, input[type=submit]');
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.submitter) return;
    var canditates = [document.activeElement, lastBtn];
    for (var i = 0; i < canditates.length; i++) {
      var candidate = canditates[i];
      if (!candidate) continue;
      if (!candidate.form) continue;
      if (!candidate.matches('button, input[type=button], input[type=image]')) continue;
      e.submitter = candidate;
      return;
    }
    e.submitter = e.target.querySelector('button, input[type=button], input[type=image]')
  }, true);
}();
